import { Link } from 'react-router-dom';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-black/80 border-t border-white/20">
      <div className="max-w-7xl mx-auto px-6 lg:px-12 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-8">
          <div>
            <h4 className="text-sm font-semibold text-white mb-4 tracking-wide">Pamela Stovall</h4>
            <p className="text-sm text-gray-300 leading-relaxed">
              Award-winning screenwriter and author.
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-white mb-4 tracking-wide">Quick Links</h4>
            <div className="grid grid-cols-2 gap-x-8 gap-y-2">
              <Link to="/" className="block text-sm text-gray-300 hover:text-white transition-colors">Home</Link>
              <Link to="/about" className="block text-sm text-gray-300 hover:text-white transition-colors">About</Link>
              <Link to="/television" className="block text-sm text-gray-300 hover:text-white transition-colors">Television</Link>
              <Link to="/news" className="block text-sm text-gray-300 hover:text-white transition-colors">News</Link>
              <Link to="/features-shorts" className="block text-sm text-gray-300 hover:text-white transition-colors">Features & Shorts</Link>
              <Link to="/contact" className="block text-sm text-gray-300 hover:text-white transition-colors">Contact</Link>
              <Link to="/books" className="block text-sm text-gray-300 hover:text-white transition-colors">Books</Link>
            </div>
          </div>
        </div>

        <div className="pt-8 border-t border-white/20 text-sm text-gray-300 text-center md:text-left">
          <p>&copy; {currentYear} Pamela Stovall. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
}
